import React from "react";
import { useTranslation } from "locales";
import FullWidthPageBackground from "components/FullWidthPageBackground";
import "./style.scss";

export default function BlockUniversityStats() {
  const { t } = useTranslation();

  const cards = [
    {
      value: "21%",
      description: t("of students used university career support to land a job"),
      source: t("Source: HESA Graduate Outcomes 2021/22"),
    },
    {
      value: "3%",
      description: t("found their role through the university careers service"),
      source: t("Source: HESA Graduate Outcomes 2021/22"),
    },
    {
      value: "53%",
      description: t("identified career support and placements as an area their university could improve"),
      source: t("Source: International Graduate Outcomes 2024"),
    },
  ];

  return (
    <div className="block-university-stats">
      <FullWidthPageBackground className="block-university-stats__background" />
      <div className="block-university-stats__content d-flex __column __align-center">
        <h2 className="block-university-stats__title h2 mb-4 text-center">{t("The employability gap, in numbers")}</h2>
        <div className="block-university-stats__description subtitle-1 fw-semibold text-center mb-10">
          {t("Three numbers that show why employability is now a strategic priority - not a service line.")}
        </div>
        <div className="block-university-stats__card-wrapper d-flex __wrap __justify-center">
          {cards.map((card, index) => (
            <div key={index} className="block-university-stats__card d-flex __column">
              <div className="block-university-stats__card-value">{card.value}</div>
              <div className="block-university-stats__card-description fw-semibold">{card.description}</div>
              <div className="block-university-stats__card-divider" />
              <div className="block-university-stats__card-source">{card.source}</div>
            </div>
          ))}
        </div>
        <div className="block-university-stats__summary subtitle-1 fw-semibold text-center">
          {t(
            "Career teams are stretched. Students lack confidence and readiness. Rankings reflect the gap. Specialist support closes it."
          )}
        </div>
      </div>
    </div>
  );
}
